import { useMemo, useState } from 'react';
import { Editor, JTinyMCEExtensionsBuilders } from 'jamespot-react-components';

export const useGifsModal = (): {
    open: boolean;
    onSelect: (v: string) => void;
    close: () => void;
    ext: ReturnType<typeof JTinyMCEExtensionsBuilders.gifs>;
    isActive?: boolean;
} => {
    const [open, setOpen] = useState(false);
    const [editor, setEditor] = useState<Editor>();
    const ext = useMemo(
        () =>
            JTinyMCEExtensionsBuilders.gifs(
                (ed) => setEditor(ed),
                () => setOpen(true),
            ),
        [],
    );
    return {
        open,
        onSelect: (v: string) => {
            editor?.execCommand('InsertHTML', false, `<img src="${v}" alt="" />`);
            setOpen(false);
        },
        close: () => setOpen(false),
        ext,
        isActive: true,
    };
};
